const METER_DATA_COUNT_FETCHING= 'METER_DATA_COUNT_FETCHING';
const METER_DATA_COUNT_FETCHED= 'METER_DATA_COUNT_FETCHED';
const METER_DATA_COUNT_FETCHING_FAILED= 'METER_DATA_COUNT_FETCHING_FAILED';
const METER_DATA_COUNT_RESET='METER_DATA_COUNT_RESET';

export{
    METER_DATA_COUNT_FETCHING,
    METER_DATA_COUNT_FETCHED,
    METER_DATA_COUNT_FETCHING_FAILED,
    METER_DATA_COUNT_RESET
}